import { createRoot } from "react-dom/client";
import App from "./App";
import { ContentProtectionProvider } from "./components/content-protection";
import "./index.css";

const BUILD_FINGERPRINT = typeof __BUILD_FINGERPRINT__ !== "undefined" ? __BUILD_FINGERPRINT__ : "unknown";
console.info(`[UWP] Build fingerprint: ${BUILD_FINGERPRINT}`);
const metaFingerprint = document.createElement("meta");
metaFingerprint.name = "build-fingerprint";
metaFingerprint.content = BUILD_FINGERPRINT;
document.head.appendChild(metaFingerprint);

const originalFetch = window.fetch;
window.fetch = function patchedFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const method = (init?.method || "GET").toUpperCase();
  const safeMethods = ["GET", "HEAD", "OPTIONS"];
  if (!safeMethods.includes(method)) {
    const url = typeof input === "string" ? input : input instanceof URL ? input.toString() : (input as Request).url;
    if (url.startsWith("/api") || url.startsWith(window.location.origin + "/api")) {
      const match = document.cookie.match(/(?:^|;\s*)resonance_csrf=([^;]*)/);
      const csrfToken = match ? decodeURIComponent(match[1]) : undefined;
      if (csrfToken) {
        const headers = new Headers(init?.headers);
        if (!headers.has("x-csrf-token")) {
          headers.set("x-csrf-token", csrfToken);
        }
        init = { ...init, headers };
      }
    }
  }
  return originalFetch.call(window, input, init);
};

const isTouchDevice = () => "ontouchstart" in window || navigator.maxTouchPoints > 0 || matchMedia("(pointer: coarse)").matches;

const FOCUSABLE = ["INPUT", "TEXTAREA", "SELECT"];
document.addEventListener("focusin", (e) => {
  if (!isTouchDevice()) return;
  const el = e.target as HTMLElement;
  if (FOCUSABLE.includes(el.tagName) || el.isContentEditable || el.getAttribute("role") === "combobox") {
    const computed = window.getComputedStyle(el).fontSize;
    const px = parseFloat(computed);
    if (px < 16) {
      el.style.setProperty("font-size", "16px", "important");
    }
  }
});

createRoot(document.getElementById("root")!).render(
  <ContentProtectionProvider>
    <App />
  </ContentProtectionProvider>
);
